var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('div',{attrs:{"id":"wrapper"}},[_c('welcome-notice'),_c('router-view')],1),_c('cookie-notice'),(_vm.messages.length > 0)?_c('toast'):_vm._e(),_c('bottom-bar'),_c('feedback-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }